import React, { Component } from 'react';
import { arrayOf, string, object, func } from 'prop-types';
import styled from 'styled-components';

import ChevronDown from './ChevronDown';
import ChevronUp from './ChevronUp';

const Wrapper = styled.div`
  z-index: 1002;
  position: relative;
  width: 194px;
  height: 48px;
  margin-bottom: 8px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 38px;
  border-radius: 4px;
  border: ${({ listOpen, textChanged }) => (listOpen || textChanged ? 'solid 1px #6e0ad6' : 'solid 1px #d2d2d2')};
  color: ${({ listOpen, textChanged }) => (listOpen || textChanged ? '#6e0ad6' : '#4a4a4a')};
  background-color: #fff;
  cursor: default;
  position: relative;
`;

const HeadeTitle = styled.div`
  font-size: 16px;
  margin-left: 16px;
  width: 100%;
  text-align: center;
  user-select: none;
`;

const List = styled.ul`
  z-index: 1003;
  position: absolute;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.22);
  margin-top: 8px;
  padding: 16px 0px;
  overflow: hidden;
`;

const Item = styled.li`
  width: 100%;
  font-size: 16px;
  line-height: 1.5;
  color: #545454;
  padding: 8px 24px;
  cursor: default;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  user-select: none;

  &:hover {
    background: #f6f6f6;
    color: #6e0ad6;
  }
`;

const Icon = styled.div`
  margin: 16px 8px;
  display: flex;
`;


class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      selectedText: this.props.title,
      textChanged: false,
    };
    this.close = this.close.bind(this);
  }

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        window.addEventListener('click', this.close);
      } else {
        window.removeEventListener('click', this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.close);
  }

  close() {
    this.setState({
      listOpen: false,
    });
  }

  selectItem(text) {
    this.setState({
      selectedText: text,
      listOpen: false,
      textChanged: true,
    });
  }

  toggleList() {
    this.setState(prevState => ({
      listOpen: !prevState.listOpen,
    }));
  }

  render() {
    const { list, onSelect } = this.props;
    const { listOpen, selectedText, textChanged } = this.state;
    return (
      <Wrapper>
        <Header onClick={() => this.toggleList()} listOpen={listOpen} textChanged={textChanged}>
          <HeadeTitle>{selectedText}</HeadeTitle>
          <Icon>
            {listOpen
              ? <ChevronUp width={16} height={16} />
              : <ChevronDown width={16} height={16} />
            }
          </Icon>
        </Header>
        {listOpen && (
          <List onClick={e => e.stopPropagation()}>
            {list.map(item => (
              <Item key={item.value} onClick={() => { this.selectItem(item.text); onSelect(item.value); }}>{item.text}</Item>
            ))}
          </List>
        )}
      </Wrapper>
    );
  }
}

Dropdown.propTypes = {
  list: arrayOf(object),
  title: string,
  onSelect: func,
};

Dropdown.defaultProps = {
  list: [],
  title: 'Selecione uma opção',
  onSelect: () => {},
};

export default Dropdown;
